import { createAsyncAction } from 'src/redux/actions';

export const EXPAND_PULL_REQUESTS = 'dashboard/EXPAND_PULL_REQUESTS';
export const FetchRepositories = createAsyncAction(
  'dashboard/FETCH_REPOSITORIES'
);
export const FETCH_NONCRITICAL_REPOSITORIES_DATA =
  'dashboard/FETCH_NONCRITICAL_REPOSITORIES_DATA';

export const LoadDashboard = createAsyncAction('dashboard/LOAD');
export const LoadDashboardOverview = createAsyncAction(
  'dashboard/LOAD_OVERVIEW'
);
export const FILTER_PULL_REQUESTS = 'dashboard/FILTER_PULL_REQUESTS';

export const CLEAR_PULL_REQUEST_FILTERS =
  'dashboard/CLEAR_PULL_REQUEST_FILTERS';
